/* eslint-disable @typescript-eslint/camelcase */
import { v4 as uuid } from 'uuid';
import Vue from 'vue';

import EventsApi from '@/api/events';

declare global {
    interface Window {
      fbq: any;
    }
  }

export const submitInitiateCheckout = (productId, quantity) => {
  try {
    const eventId: string = uuid();
    EventsApi.submitInitiateCheckout({ eventId, contentIds: [productId], quantity });
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout',
        {
          content_ids: [productId],
          num_items: quantity,
          eventref: 'fb_oea' // or set to empty string
        },
        {
          eventID: eventId
        });
    }
  } catch (error) {
    Vue.$log.error(error);
  }
}

export const submitCategoryView = (categoryId) => {
  const contentType = 'product_group';
  try {
    const eventId: string = uuid();
    EventsApi.submitViewContent({ eventId, contentIds: [categoryId], contentType });
    if (window.fbq) {
      window.fbq('track', 'ViewContent',
        {
          content_ids: [categoryId],
          content_type: `${contentType}`
        },
        {
          eventID: eventId
        });
    }
  } catch (error) {
    Vue.$log.error(error);
  }
}

export const submitProductView = (productId) => {
  const contentType = 'product';
  try {
    const eventId: string = uuid();
    EventsApi.submitViewContent({ eventId, contentIds: [productId], contentType });
    if (window.fbq) {
      window.fbq('track', 'ViewContent',
        {
          content_ids: [productId],
          content_type: `${contentType}`
        },
        {
          eventID: eventId
        });
    }
  } catch (error) {
    Vue.$log.error(error);
  }
}

export const submitPurchase = (basketTotal: number, productIds: string[] | number[]) => {
  try {
    const eventId: string = uuid();
    EventsApi.submitPurchase({ eventId, contentIds: productIds, contentType: 'product', value: basketTotal, currency: 'USD' });
    if (window.fbq) {
      window.fbq('track', 'Purchase',
        {
          value: basketTotal,
          currency: 'USD',
          content_type: 'product',
          content_ids: productIds,
          num_items: productIds.length
        },
        {
          eventID: eventId
        });
    }
  } catch (error) {
    Vue.$log.error(error);
  }
}
